import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

const AboutUs = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);
    return (
        <div className='gradientdiv h-fit w-full mt-16 lg:mt-10 visible overflow-x-hidden'>
            <div className='font-sans px-4 lg:px-[15%] flex flex-col justify-center items-center mt-5 lg:mt-20 mb-10'>
                <p className='text-primary text-xl lg:text-3xl font-bold mb-10 lg:mb-20'>OUR APPROACH</p>
                {/* <p className='text-black text-xl lg:text-3xl font-semi-bold w-full my-4'>Our Approach</p> */}
                <div className='text-gray-500 flex flex-col font-semibold gap-4 max-md:text-xs leading-5'>
                    <p>We believe that any individual customer today deserves to get financial services in a manner that is uniquely suited to them. Unfortunately, the present system has two flaws. One, that it designs solutions that are basis half-baked profiles. Two, the incentives and sales pressure drive solutions and not what's right for the consumer.</p>
                    <p>We want to tackle both of these problems. For the profile part, we are in the process of building an amazing UI/UX and Data Science driven solution which will make the profile unique to the consumer</p>
                    <p>For providing a solution to the consumer, we are building a recommendation engine which is machine-driven but learns from experts</p>
                    <p>By building the above we are refreshing the consumers interact with financial products while giving power in the hands of consumers to make independent and correct financial decisions</p>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default AboutUs